import React from 'react';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { CircularProgress } from '@material-ui/core';
/**
 * This receives a props with 2 elements (Categories and SeriesData)
 * @param {idCategories, SeriesData} props
 *
 */

const BarChartNpsScore = props => {
    const data = props.data;

    let xAxisCategories = [];
    let scoreNps = [];

    if (data) {
        for (const element in data) {
            xAxisCategories.push(data[element].date);
            scoreNps.push(data[element].scoreNps * 100);
        }
    }

    const options = {
        chart: {
            type: 'line',
        },
        title: {
            text: 'Nps Histórico',
        },
        xAxis: {
            categories: xAxisCategories,
            allowDecimals: false,
        },
        series: [
            {
                name: 'Score Nps',
                type: 'column',
                data: scoreNps,
                allowDecimals: false,
            },
        ],
    };

    return (
        <React.Fragment>
            {props.isLoading ? (
                <CircularProgress />
            ) : (
                <HighchartsReact highcharts={Highcharts} options={options} />
            )}
        </React.Fragment>
    );
};

export default React.memo(BarChartNpsScore);
